export default __webpack_public_path__ + "static/media/quiz_on.7c36873c.png";